export const safeDeepClone = (obj) => {
  if (obj === null || typeof obj !== "object") return obj;

  if (obj instanceof Date) return new Date(obj.getTime());

  if (Array.isArray(obj)) {
    return obj.map((item) => safeDeepClone(item));
  }

  if (
    obj instanceof Event ||
    obj instanceof Node ||
    (typeof obj.constructor === "function" &&
      obj.constructor.name.includes("Event"))
  ) {
    console.warn(
      "Keeping original reference for non-cloneable object:",
      obj.constructor.name
    );
    return obj;
  }

  // regular objects
  const cloned = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      try {
        cloned[key] = safeDeepClone(obj[key]);
      } catch (error) {
        console.warn(`Error cloning property ${key}:`, error);
        cloned[key] = obj[key]; // keep original reference as fallback
      }
    }
  }

  return cloned;
};
